import { getHubOwners } from './get-hub-owners';

export const getContracts = async (): Promise<any> => {
  const contracts = await getHubOwners();

  return contracts.map(({ hubs, ...contract }) => contract);
};
